import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';

class MailerLiteForm extends Component {

	constructor(){
		super();
		this.state = {
			displayForm: true,
			displaySuccess: false,
		};
	}

	componentDidMount() {
		// success function
		// register it on the window object
		window[`ml_webform_success_4983348`] = () => {
			this.setState({
				displayForm: false,
				displaySuccess: true,
			});
		};

		const scriptMailerLite = document.createElement("script");
		scriptMailerLite.src = "https://static.mailerlite.com/js/w/webforms.min.js?vaa4d608450783acdc64d5338ff94f6d5";
		document.body.appendChild(scriptMailerLite);
	}

	render() {

		const {displayForm, displaySuccess} = this.state;

		return (
			<div id="mlb2-4983348" className="ml-subscribe-form ml-subscribe-form-4983348">
				<div className="ml-vertical-align-center">
					<div className="subscribe-form ml-block-success" style={displaySuccess ? {} : {display:'none'}}>
						<div className="form-section">
							<h4><FormattedMessage id="mailerlite.success.title"/></h4>
							<p><FormattedMessage id="mailerlite.success.message"/></p>
						</div>
					</div>
					<form className="ml-block-form"
					      style={displayForm ? {} : {display:'none'}}
					      action="https://landing.mailerlite.com/webforms/submit/w4r0x4"
					      data-id="407390"
					      data-code="w4r0x4" method="POST"
					      target="_blank">
						<div className="subscribe-form">
							<div className="form-section mb10">
								<h4><FormattedMessage id="mailerlite.form.title"/></h4>
								<p><FormattedMessage id="mailerlite.form.message"/></p>
							</div>
							<div className="form-section">
								<div className="form-group ml-field-email ml-validate-required ml-validate-email">
									<FormattedMessage id="mailerlite.form.input.email">
										{
											(msg) => (
												<input type="email" name="fields[email]" className="form-control"
												       placeholder={msg} autoComplete="email"
												       x-autocompletetype="email" spellCheck="false"
												       autoCapitalize="off" autoCorrect="off"/>
											)
										}
									</FormattedMessage>
								</div>
								<div className="form-group ml-field-name ml-validate-required">
									<FormattedMessage id="mailerlite.form.input.name">
										{
											(msg) => (
												<input type="text" name="fields[name]"
												       className="form-control" placeholder={msg}
												       autoComplete="name" x-autocompletetype="name"
												       spellCheck="false" autoCapitalize="off" autoCorrect="off"/>
											)
										}
									</FormattedMessage>
								</div>
								<div className="form-group ml-field-phone">
									<FormattedMessage id="mailerlite.form.input.phone">
										{
											(msg) => (
												<input type="text" name="fields[phone]" className="form-control"
												       placeholder={msg} spellCheck="false"
												       autoCapitalize="off" autoCorrect="off"/>
											)
										}
									</FormattedMessage>
								</div>
							</div>
							<input type="hidden" name="ml-submit" value="1"/>
							<button type="submit" className="primary">
								<FormattedMessage id="mailerlite.form.button.subscribe"/>
							</button>
							<button disabled="disabled" style={{display: 'none'}} type="button" className="loading">
								<img src="https://static.mailerlite.com/images/rolling@2x.gif"
								     width="20" height="20"
								     alt="Loading..."
								     style={{width: 20+'px', height: 20+'px'}}/>
							</button>
						</div>
					</form>
				</div>
			</div>
		);
	}
}

export default MailerLiteForm;


// WEBPACK FOOTER //
// ./src/components/form/MailerLiteForm.js